exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div {\n  text-align: left; }\n\ndiv.row {\n  margin-bottom: 15px; }\n  div.row div {\n    padding-left: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/lawyers/lawyers.component.scss
// module id = 344
// module chunks = 1